module.exports = __webpack_public_path__ + "img/24.88246ff7.svg";